import { globalVariables } from "helper/globalVariables";
import React, { useEffect, useRef, useState } from "react";
import moment from "moment";
import "./modules.css";

import Dropdown from "shared/Components/dropdown";
import { dropdowns } from "./Components/constant";
import { BottomButtons } from "shared/Components/bottomButtons";
import { useMediaQuery } from "react-responsive";
import {
  DocsSignupMutation,
  getSearchByTrialCalendarIdQuery,
} from "redux/features/trialCalendar/trialCalendarGql";
import { client } from "helper/apolloConfig";
import { PopUpMessages } from "shared/Components/popUpMessages";
import { TextButton } from "shared/Components/textButton";
import { getAllTitlesEarnedQuery,  getRegisteredDogSITByIdQuery, checkForAlreadyRequestQuery } from "redux/features/dogSlice/dogGql";
import { getRegisteredDogsTrialByTrialCalendarQuery } from "redux/features/hostSlice/trailCalendar/dogsTrialCalendarGql";
import { useLazyQuery } from "@apollo/client";
import { orderSearchesElements } from "helper/orderSearchElements";

export const DogSignUp = ({ setDogSignup, detail, dogSuggestions }) => {
  const modalRef = useRef();

  const divisionModalRef = useRef();

  const isMobile = useMediaQuery({ query: "(max-width: 1024px)" });

  const isSmallMobile = useMediaQuery({ query: "(max-width: 630px)" });

  const [searchContainersData, setSearchContainersData] = useState([]);

  const [selectDog, setSelectedDog] = useState({});

  const [signUpDog, setSignUpDog] = useState([]);

  const [loading, setLoading] = useState(false);

  const [isloading, setIsLoading] = useState(false);

  const [checkValidation, setCheckValidation] = useState(false);

  const [apiData, setApiData] = useState({
    title: "",
    desc: "",
    type: "pending",
    noCallBack: false,
  });

  const [tempSignUpDog, setTempSignUpDog] = useState({
    dog: "",
    dogId: "",
    elements: "",
    searchId: null,
    searchLabel: "", // display label e.g. "Novice Interiors 2"
    division: "",
  });

  const alreadyHaveRequestHandler = async (dogData) =>  {
    setIsLoading(true); 
    try {
      const { data } = await client.query({
        query: checkForAlreadyRequestQuery,
        variables: dogData,
      });
      return data;
    } catch (error) {
      return { hasError: true, message: error.message };
    } finally {
      setIsLoading(false); 
    }
  }
  
  const [
    getAllTitlesEarned,
    {
      data: allTitlesEarned,
    },
  ] = useLazyQuery(getAllTitlesEarnedQuery, {
    fetchPolicy: "no-cache",
  });

  const [
    getRegisteredDogSIT,
    {
      data: dogSITData,
    },
  ] = useLazyQuery(getRegisteredDogSITByIdQuery, {
    fetchPolicy: "no-cache",
  });

  const [getData, { data: checkdogEntriesList }] = useLazyQuery(getRegisteredDogsTrialByTrialCalendarQuery);
  const resultData = checkdogEntriesList?.getRegisteredDogsTrialByTrialCalendar.data;

  useEffect(() => {
    getSearchContainersDropdown();
    getData({
      variables: {
        trialCalendarId: parseInt(detail?.id),
        pageNumber: 1,
        pageSize: 1000,
      },
    });
  }, []);

  const getSearchContainersDropdown = async () => {
    try {
      const result = await client.query({
        query: getSearchByTrialCalendarIdQuery,
        variables: {
          trialCalendarId: parseInt(detail?.id),
        },
      });

      const data = result?.data?.getSearchByTrialCalendarId;
      if (data) {
        const searchContainers = data?.map((e) => ({
          id: e?.id,
          label: e?.searchName,
          element: e?.element, // underlying element value for backend validation
        }));
        setSearchContainersData(searchContainers);
      }
    } catch (e) {}
  };

  function canDogSignUp(titlesEarned, event, division) {
    if(division == "Pro") return;

    if(event.includes("SIT")) return;
    
    if(event.includes("Novice")) return;

    const UpdatedEvent = event.replace(/\d+/g, '').trim();
    
    const prerequisites = {
      "Premier Short Trial": "Excellent Interiors",
      "Premier Short Trial": "Excellent Exteriors",

      "Premier Full Trial": "Excellent Interiors",
      "Premier Full Trial": "Excellent Exteriors",

      "Advanced Containers": "Novice Containers",
      "Excellent Containers": "Advanced Containers",
      
      "Advanced Exteriors": "Novice Exteriors",
      "Excellent Exteriors": "Advanced Exteriors",

      "Advanced Interiors": "Novice Interiors",
      "Excellent Interiors": "Advanced Interiors",

      "Advanced FastFinds": "Novice FastFinds",
      "Excellent FastFinds": "Advanced FastFinds",

      "Advanced Solo": "Novice Solo",
      "Excellent Solo": "Advanced Solo",
    };

    const requiredTitle = prerequisites[UpdatedEvent];

    if(selectDog.noviceLevel && event.includes("Advanced")) return;

    const titleToInclude = event.includes("Advanced")
      ? "Novice"
      : event.includes("Excellent")
      ? "Advanced"
      : event.includes("Premier")
      ? "Excellent"
      : null;
    
    const filterTitleEarned = titlesEarned?.filter(e => e.type.includes(titleToInclude))  ?? [];
  
    const hasRequiredTitle = filterTitleEarned[0]?.titleEarned?.some(title => title.search === requiredTitle)  ?? false;

    const isPremierSearch = event.includes("Premier");

    if (!hasRequiredTitle && isPremierSearch) {
      let errorMessage = `You must have a title in Excellent Interiors and Excellent Exteriors to qualify to enter in a Premier trial.`;
      return { hasError: true, message: errorMessage };
    }

    if (!hasRequiredTitle && !isPremierSearch) {
      let errorMessage = `You cannot enter ${event} as you do not have a title in ${requiredTitle}`;
      return { hasError: true, message: errorMessage };
    }
  }

  const checkAlreadyTitle = (titlesEarned, event, division) => {
    const isNoviceSkip = event.includes("Novice") && selectDog.noviceLevel && division !== "Pro";
    
    if (isNoviceSkip) return { hasError: true, message: `Your dog has skipped ${event} in the Standard division. Your dog can now be entered in the Pro division or the Advanced level.` };

    if(division == "Pro" && selectDog.noviceLevel && event.includes("Novice")) return;

    const UpdatedEvent = event.replace(/\d+/g, '').trim();

    const filterTitleEarned = titlesEarned?.filter(e => e.type.includes(event.split(" ")[0]))  ?? [];

    const hasRequiredTitle = filterTitleEarned?.[0]?.titleEarned?.some(title => title.search === UpdatedEvent) ?? false;
    
    if (division == "Pro" && !hasRequiredTitle) {
      return { hasError: true, message: `You don't qualify for the Pro Division since you don't have a Standard Division title in ${event}.` };
    }
    
    if (division == "Pro" && hasRequiredTitle) return;

    const titleEarned = event.includes("Novice")
    ? "Advanced"
    : event.includes("Advanced")
    ? "Excellent"
    : null;

    if (hasRequiredTitle) {
        const levelMessage = titleEarned ? `or the ${titleEarned} level.` : '.';
        return {
            hasError: true,
            message: `Your dog has already earned a title in the Standard division for ${event}. Your dog can now be entered in the Pro division ${levelMessage}`
        };
    }
  };

  const checkAlreadySearch = (elements) => {
    const alreadyHaveSearch = signUpDog.some(dog => {
      if (dog.dogId !== tempSignUpDog.dogId) return false;
      // If both entries have a searchId, compare by searchId (exact room match).
      // This allows "Excellent Containers" and "Excellent Containers 2" to coexist.
      if (dog.searchId && tempSignUpDog.searchId) return dog.searchId === tempSignUpDog.searchId;
      // Fall back to raw element string comparison for entries without searchId.
      return dog.elements === elements;
    });
    return alreadyHaveSearch;
  };

  const onChangeDog = (option, name) => {
    setTempSignUpDog(prev => ({
      ...prev,
      [name]: option,
      dogId: parseInt(selectDog.id, 10),
      dog: selectDog.call_name,
    }));
  };
  
  const handleAddSearch = async () => {
    if (!(tempSignUpDog.dog && tempSignUpDog.elements && tempSignUpDog.division)) {
      setCheckValidation(true);
      return;
    }

    const { anise, birch, clove } = dogSITData.getRegisteredDogSITById;

    const selectedElement = tempSignUpDog.elements;

    const selectedDivision = tempSignUpDog.division;

    const showModal = (title, desc) => {
      setApiData({
        title,
        desc,
        type: "pending",
        noCallBack: true,
      });
      divisionModalRef.current.openModal();
    };
    
    const matchingEntry = resultData.some(
      (entry) =>
        entry.dog === tempSignUpDog.dog &&
        entry.division === tempSignUpDog.division &&
        (tempSignUpDog.searchId
          ? entry.searchId === tempSignUpDog.searchId
          : entry.elements === tempSignUpDog.elements)
    );

    if (matchingEntry) {
      showModal(
        "Ooops!",
        `Your dog has already been entered in ${tempSignUpDog.searchLabel || tempSignUpDog.elements}. Please choose another search.`
      );
      return;
    }

    const sitPassed = {
      "Anise SIT": anise,
      "Birch SIT": birch,
      "Clove SIT": clove,
    };

    const elements = ["Birch", "Anise", "Clove"];

    const checkElements = signUpDog.some(e => e.elements == "Birch SIT");
  
    if (selectedDivision !== "FEO") {
        const missingTitleElement = elements.find(element => selectedElement.includes(element) && eval(element.toLowerCase()) === "Miss");

        if (missingTitleElement && selectedDivision == "Pro") {
          showModal("Ooops!", `You don't qualify for the Pro Division since you don't have a Standard Division title in ${selectedElement}.`);
          return;
        }

      if (!selectedElement.includes("Birch") && birch === "Miss" && selectedElement && !checkElements) {
        showModal("Ooops!", `You must pass the Birch SIT to enter ${selectedElement}`);
        return;
      }
    
      if (sitPassed[selectedElement] === "Pass" ) {
        showModal("Ooops!", `You have already passed the ${selectedElement}.`);
        return;
      }
    
      if (selectedElement.includes("Novice") && birch === "Miss" && selectedElement) {
        showModal("Ooops!", `You must pass the Birch SIT to enter ${selectedElement}`);
        return;
      }
    
      if (
        selectedElement.includes("Advanced") &&
        (anise === "Miss" || clove === "Miss")
      ) {
        showModal("Ooops!", `You must pass the Anise and Clove SITs to enter ${selectedElement}`);
        return;
      }
      
      const alreadyHaveTitle = checkAlreadyTitle(
        allTitlesEarned?.getAllTitlesEarned?.data,
        selectedElement,
        tempSignUpDog.division
      );

      if (alreadyHaveTitle?.hasError) {
        showModal("Ooops!", alreadyHaveTitle.message);
        return;
      }

      const response = canDogSignUp(
        allTitlesEarned?.getAllTitlesEarned?.data,
        selectedElement,
        tempSignUpDog.division
      );
      
      if (response?.hasError) {
        showModal("Ooops!", response.message);
        return;
      }
    }

    const alreadyHaveSearch = checkAlreadySearch(
      selectedElement
    );

    if (alreadyHaveSearch) {
      showModal(
        "Search Already Added",
        `The ${selectedElement} Search has already been added`
      );
      return;
    }

    const alreadyHaveRequest = await alreadyHaveRequestHandler({
      ...tempSignUpDog,
      trialCalendarId: parseInt(detail?.id, 10),
    });

    if (alreadyHaveRequest?.hasError) {
      showModal(
        "Search Already Added",
        `The ${selectedElement} Search has already been added`
      );
      return;
    }

    // Check if handler already has a different dog in this search (unless FEO)
    if (selectedDivision !== "FEO") {
      const handlerHasDifferentDogInSearch = signUpDog.find(entry =>
        entry.elements === selectedElement &&
        entry.dogId !== tempSignUpDog.dogId &&
        entry.division !== "FEO"
      );

      if (handlerHasDifferentDogInSearch) {
        showModal(
          "Cannot Enter Multiple Dogs",
          `You have already entered a dog in ${selectedElement}. You cannot enter another dog in the same search. Please enter as FEO or choose another element.`
        );
        return;
      }
    }

    // Only include fields accepted by CreateDogTrialInput — strip display-only fields
    const { searchLabel, ...signupFields } = tempSignUpDog;
    setSignUpDog((prevSignUpDog) => [{
      trialCalendarId: parseInt(detail?.id, 10),
      ...signupFields
    }, ...prevSignUpDog]);
    
    setCheckValidation(false);

    setTempSignUpDog({
      dog: "",
      dogId: "",
      elements: "",
      searchId: null,
      searchLabel: "",
      division: "",
    });
  };

  const onDogSelection = value => {
    const currentOption = dogSuggestions.find(e =>
      e.call_name.includes(value)
    );
  
    if (!currentOption) return;
  
    getAllTitlesEarned({
      variables: {
        pageNumber: 1,
        pageSize: 30,
        dogId: currentOption.id,
      },
    });

    getRegisteredDogSIT({
      variables: {
        dogId: currentOption.id,
      },
    });
  
    if (currentOption.status == "Pending") {
      setApiData({
        title: globalVariables.pendingPayment,
        desc: globalVariables.paymentIsPending,
        type: "pending",
        noCallBack: true,
      });
      modalRef.current.openModal();
      return;
    }
    
    setSelectedDog(currentOption);
    setTempSignUpDog(prev => ({
      ...prev,
      dogId: parseInt(currentOption.id, 10),
      dog: currentOption.call_name,
    }));
  };

  const onGoNext = async () => {
    if (signUpDog?.length < 1) {
      setCheckValidation(true);
      return;
    }

    if (signUpDog?.length > 0) {
      setCheckValidation(false);
      try {
        setLoading(true);
        await client.mutate({
          mutation: DocsSignupMutation,
          variables: { data: signUpDog },
        });

        setLoading(false);
        setSignUpDog([]);
        modalRef.current.openModal();
        setApiData({
          ...apiData,
          title: "Success!",
          desc: "You will be notified if your entries were chosen after the random draw is performed",
          type: "success",
        });
      } catch (error) {
        modalRef.current.openModal();
        setApiData({
          ...apiData,
          title: globalVariables.error,
          desc: error?.message,
          type: "pending",
        });
        setLoading(false);
      }
    }
  };

  const onGoBack = () => {
    setDogSignup(false);
  };

  const DogGroups = ({ data}) => {
    const groupedDogs = data.reduce((acc, item) => {
      if (!acc[item.dogId]) {
        acc[item.dogId] = [];
      }
      acc[item.dogId].push(item);
      return acc;
    }, {});
  
    const handleRemoveDog = (elements, dogId) => {
      const removeElements = signUpDog.filter(dog => !(dog.elements === elements && dog.dogId === dogId));
      setSignUpDog(removeElements);
    };
    
    return (
      <div className="w-full mt-4">
        {Object.entries(groupedDogs).map(([dogId, dogs]) => {
          const uniqueDogs = dogs.reduce((acc, dog) => {
            if (!acc.some((d) => d.dog === dog.dog)) {
              acc.push(dog);
            }
            return acc;
          }, []);

          const validDogs = dogs.filter(d => d.elements && d.division);
  
          if (validDogs.length === 0) return null;
  
          return (
            <div key={dogId} className="relative border rounded-md shadow-100 p-4 mb-4">
              <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-white px-3 font-bold text-2xl text-purple-200">
                {uniqueDogs.map((dog) => dog.dog).join(", ")}
              </div>
  
              {uniqueDogs.map((dog, index) => {
                const dogEntries = validDogs.filter(d => d.dog === dog.dog);
  
                if (dogEntries.length === 0) return null;
  
                return (
                  <div key={index} className="text-gray-800">
                    {dogEntries.map((d, idx) => (
                      <div key={idx} className="mb-2 px-4 flex justify-between items-center border-b pb-2">
                        <div>
                          <p><strong>Element:</strong> {(d.searchId && searchContainersData.find(s => s.id === d.searchId)?.label) || d.elements}</p>
                          <p><strong>Division:</strong> {d.division}</p>
                        </div>
                        <button 
                          className="text-red font-bold px-3 py-1 rounded hover:bg-red-600 transition"
                          onClick={() => handleRemoveDog(d.elements, d.dogId)}
                        >
                          Remove
                        </button>
                      </div>
                    ))}
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>
    );
  };

  const isPremiumSearch = tempSignUpDog.elements.includes("Premier")

  const RenderAccordionBody = () => {
    return (
      <div className="w-full border rounded-md shadow-100  px-4 py-8">
          <div className="flex flex-col gap-4">
            <Dropdown
              dropdownOptions={dogSuggestions?.map(dog => dog?.call_name) ?? []}
              width="w-[100%]"
              dynamicHeight
              placeholder={globalVariables.dogDropdown}
              checkValidation={checkValidation}
              defaultOption={selectDog.call_name}
              onChange={value => onDogSelection(value)}
            />
             <Dropdown
                width="w-[100%]"
                dropdownOptions={orderSearchesElements(searchContainersData, "label").map(dog => dog?.label) ?? []}
                placeholder={globalVariables.selectSearch}
                checkValidation={checkValidation}
                onChange={label => {
                    const matched = searchContainersData.find(s => s.label === label);
                    setTempSignUpDog(prev => ({
                      ...prev,
                      elements: matched?.element ?? label,
                      searchId: matched?.id ?? null,
                      searchLabel: label, // preserve exact display name e.g. "Novice Interiors 2"
                    }));
                }}
                defaultOption={tempSignUpDog.searchLabel || tempSignUpDog.elements}
             />
            {dropdowns?.map((dropdown, index) => {
              const dropdownOptions = isPremiumSearch ? dropdown.options.filter(e => e !== "Pro") : dropdown.options;
                return (
                  <React.Fragment key={index}>
                    <Dropdown
                      dropdownOptions={dropdownOptions}
                      width="w-[100%]"
                      dynamicHeight
                      placeholder={dropdown.placeHolder}
                      checkValidation={checkValidation}
                      defaultOption={tempSignUpDog[dropdown.name]}
                      onChange={value => onChangeDog(value, dropdown.name)}
                    />
                  </React.Fragment>
                );
            })}
            <div className="flex justify-end">
              <TextButton disabled={isloading} onClick={handleAddSearch} label="Save Entry" />
            </div>
          </div>
      </div>
    );
  };

  const onCloseModal = () => {
    if (apiData?.noCallBack) {
      setApiData({ title: "", desc: "", type: "pending", noCallBack: false });
    } else if (apiData?.type === "success") {
      setDogSignup(false);
    }
  };

  return (
    <>
      <div className="flex justify-center my-8 flex-col items-center sm:p-[16px]">
        <div className="flex flex-col gap-2 w-[380px]">
          <div className=" border rounded-md shadow-100 p-4">
            <p className="text-gray-900 text-lg font-semibold leading-[30px] font-sans">
              {detail?.trail?.trialName}
            </p>
            <p className="text-gray-900 text-lg font-semibold leading-[30px] font-sans">
              {moment.utc(detail?.trail?.trialDate).format(
                "MMM DD, YYYY [–] dddd"
              )}
            </p>
          </div>
          <RenderAccordionBody />
          <DogGroups data={signUpDog}/>
        </div>     
      </div>
      <BottomButtons
        outlineLabel={globalVariables.back}
        fullLabel={globalVariables.signUp}
        onTapYes={onGoNext}
        onTapNo={onGoBack}
        position={"fixed"}
        dogSign={true}
        extraClass={
          isMobile
            ? isSmallMobile
              ? "h-[80px] w-[118vw]"
              : "h-[80px] w-[108vw] pr-0"
            : "dog-signup-bb-h"
        }
        disabled={loading}
      />
      <PopUpMessages
        title={apiData.title}
        desc={apiData.desc}
        type={apiData.type}
        ref={modalRef}
        onCloseModal={onCloseModal}
      />
      <PopUpMessages
        title={apiData.title}
        desc={apiData.desc}
        type={apiData.type}
        ref={divisionModalRef}
        onCloseModal={() => {}}
      />
    </>
  );
};
